module.exports = __webpack_public_path__ + "img/ele2.18726d8a.jpg";